var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container-fluid"},[_c('ul',{staticClass:"nav"},[_c('li',{staticClass:"nav-item"})]),_c('div',{staticClass:"copyright"})])])
}]

export { render, staticRenderFns }